export const GET_SKILLS = 'GET_SKILLS'
